import angular from 'angular';
import Navbar from './navbar/navbar';
import Footer from './footer/footer';
import User from './user/user';
import LanguageSelector from './languageSelector/languageSelector';
import stSelect from './stSelect/stSelect';
import stSelectFilter from './stSelectFilter/stSelectFilter';
import stBrowserAlerts from './stBrowserAlerts/stBrowserAlerts';
import Auth from './auth/auth';
import Loader from './loader/loader';
import stGlobalPreloader from './stGlobalPreloader/stGlobalPreloader';
import stLocation from './stLocation/stLocation';
import stExtras from './stExtras/stExtras';
import stPassengers from './stPassengers/stPassengers';
import stPrefixes from './stPrefixes/stPrefixes';
import stDateTimePicker from './stDateTimePicker/stDateTimePicker';

const commonModule = angular.module('app.common', [
        Navbar,
        User,
        Footer,
        LanguageSelector,
        stSelect,
        stBrowserAlerts,
        stSelectFilter,
        Auth,
        Loader,
        stGlobalPreloader,
        stLocation,
        stExtras,
        stPassengers,
        stPrefixes,
        stDateTimePicker
    ])
    .name;

export default commonModule;


// WEBPACK FOOTER //
// ./client/app/common/common.js